module.exports = __webpack_public_path__ + "img/woman-filled-green.5569f0b6.svg";